'use strict';

angular.module('mediacloudApp')
    .factory('Validate', function ($resource) {
        return $resource('api/validate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });
    });


